import { Flex } from "antd";
import { DatosEntrenador, Botonera } from "../../../Components/Player/Perfil";

export const Configuracion = () => {
  return (
    <Flex justify="center" align="center">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "10px",
          paddingBottom: "-15%",
          marginTop: "4rem",
        }}
      >
        <DatosEntrenador />

        <Botonera />
      </div>
    </Flex>
  );
};
